import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AXRiverRunDownRequest, AXRiverRunDownResponse } from '../Models/ax-river-rundown';
import { convertKeysToCamelCase } from '../Resources/Functions/convert-to-camel-case';

@Injectable({
  providedIn: 'root',
})
export class RiverRundownService {
  OBPortalSvcURL = '';
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(
    private appConfigService: AppConfigService,
    private httpClient: HttpClient
  ) {
    this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
  }

  public getRiverRundown(
    rebcode: string | undefined,
    evtCode: string | undefined,
    asofdate: string | undefined,
    enddate: string | undefined
  ): Observable<any> {
    this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
    const RiverRundownInfo: JSON = <JSON>(<unknown>{
      rebcode: rebcode,
      evtCode: evtCode,
      asofdate: asofdate,
      enddate: enddate,
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.post<any>(
      this.OBPortalSvcURL + 'GetRiverRundown',
      RiverRundownInfo,
      { headers: headers }
    ).pipe(
        map((response) => convertKeysToCamelCase(response))
      );
  }

  public AXRiverRunDown(
    bookingCode: string | null,
    cruiseCode: string,
    date: string,
  ): Observable<AXRiverRunDownResponse> {
    // CREATE HTTP REQUEST PAYLOAD....
    const body: AXRiverRunDownRequest = {
      BookingCode: bookingCode,
      CruiseCode: cruiseCode,
      Date: date
    };
    // SEND OUR REQUEST AND THEN RETURN THE FULL RESPONSE...
    return this.httpClient.post<AXRiverRunDownResponse>(
      `${this.OBPortalSvcURL}Ax/RiverRunDown`,
      body,
      { headers: this.headers }
    );
  }
}
